import { inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export const translateInstantUtility = () => {
  const translateService: TranslateService = inject(TranslateService);
  return (text: string, params: any = {}) => translateService.instant(text, params);
};
